import "./FeatureCard.css";
import {Icon} from "react-bootstrap-icons";

interface Props {
    name: string;
    description: string;
    icon: Icon;
    path: string;
    isLoading: boolean
    disabled?: boolean
}

export const FeatureCard = ({name, description, icon: IconComponent, path,isLoading, disabled}: Props) => {
    return (
        <a href={!disabled ? path : "#"} className={`m-2 border-custom position-relative ${isLoading? 'placeholder' : null}  ${disabled ? 'disabled' : null}`}>
            {isLoading ?
                <div className="loader_wrapper position-absolute top-50 start-50 translate-middle pointer-loading">
                    <svg className="loader" width="30" height="30" viewBox="0 0 44 44">
                        <circle cx="22" cy="22" r="20" fill="none" strokeWidth="4"></circle>
                    </svg>
                </div>
            :null}
            <div className="row mb-4">
                <div className="col-12 d-flex justify-content-end">
                    <IconComponent className={`m-3 ${disabled ? 'color-disabled' : 'text-secondary'}`} size={30}/>
                </div>
            </div>
            <div className="row m-2 mb-3">
                <div className="col-12">
                    <h5>{name}</h5>
                </div>
                <div className="col-12 m-0 text-truncate">
                    <p className={"description"}>{description}</p>
                </div>
            </div>
        </a>
    );
};
